import { money, fmtDate, fmtTime } from "./format";

const esc = (v) => {
  const s = v == null ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

const COLUMNS = [
  ["Moving date", (b) => b.moving_date],
  ["Move Pro job number", (b) => b.job_number],
  ["Status", (b) => b.status],
  ["Customer", (b) => b.customer_name],
  ["Mobile", (b) => b.mobile],
  ["Email", (b) => b.email],
  ["Pickup", (b) => b.pickup_address],
  ["Delivery", (b) => b.delivery_address],
  ["Start time", (b) => fmtTime(b.start_time)],
  ["Job type / route", (b) => b.job_type],
  ["State", (b) => b.state],
  ["Booked by", (b) => b.sales_person],
  ["Driver / team", (b) => b.assigned_team],
  ["Truck", (b) => b.truck_assigned],
  ["Removalists", (b) => b.men],
  ["Pricing type", (b) => b.pricing_type],
  ["Hourly rate", (b) => b.hourly_rate],
  ["Estimated hours", (b) => b.estimated_hours],
  ["Call-out hours", (b) => b.callout_hours],
  ["Hours worked", (b) => b.hours_worked],
  ["Fixed price", (b) => b.fixed_price],
  ["Rate per m3", (b) => b.price_per_m3],
  ["Cubic metres", (b) => b.cubic_metres],
  ["Call-out fee", (b) => b.callout_fee],
  ["Additional charges", (b) => b.additional_charges],
  ["Driver extras", (b) => (b.driver_extras || []).map((e) => `${e.type}${e.description ? ` (${e.description})` : ""} $${e.amount}`).join("; ")],
  ["Driver extras total", (b) => b.driver_extras_total],
  ["Total price", (b) => b.total_estimate],
  ["Deposit paid", (b) => b.deposit_amount],
  ["Deposit method", (b) => b.deposit_method],
  ["Outstanding balance", (b) => b.remaining_balance],
];

export function bookingsToCsv(bookings) {
  const live = bookings.filter((b) => b.status !== "Cancelled");
  const sum = (f) => live.reduce((s, b) => s + (Number(b[f]) || 0), 0).toFixed(2);
  const lines = [COLUMNS.map(([h]) => esc(h)).join(",")];
  bookings.forEach((b) => lines.push(COLUMNS.map(([, fn]) => esc(fn(b))).join(",")));
  lines.push("");
  lines.push(`TOTALS (excluding cancelled),${live.length} jobs`);
  lines.push(`Total job value,${sum("total_estimate")}`);
  lines.push(`Deposits paid,${sum("deposit_amount")}`);
  lines.push(`Driver extras,${sum("driver_extras_total")}`);
  lines.push(`Outstanding,${sum("remaining_balance")}`);
  return lines.join("\r\n");
}

export function downloadCsv(filename, text) {
  const blob = new Blob(["\ufeff" + text], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = Object.assign(document.createElement("a"), { href: url, download: filename });
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const csvFilename = (filters) => `bookings-${filters.sales_person ? filters.sales_person.replace(/\s+/g, "-").toLowerCase() + "-" : ""}${fmtDate(new Date().toISOString().slice(0, 10), "yyyy-MM-dd")}.csv`;

export { money };
